const _i18n_msg = {
  steps : {
    EN: ['Tell us your FQDN(Domain)', 'Set Scanning Policy', 'Agreement on Terms of Use', 'Complete'],
    KO: ['저희에게 도메인을 알려주세요', '정책을 설정해주세요', '확인해주세요', '완료되었어요!'],
    JP: ['FQDN(ドメイン)を教えてください', 'スキャンポリシーの設定', '利用規約への同意', '完了'],
  },
}

const _i18n_error = {
  require_fqdn : {
    EN: `require FQDN(domain)`,
    KO: `require FQDN(domain)`,
    JP: `FQDN(ドメイン)が必要です`
  },
  fqdn_check : {
    EN: `FQDN(domain) is incorrect`,
    KO: `FQDN(domain) is incorrect`,
    JP: `FQDN(ドメイン)が正しくありません`
  },
  is_start : {
    EN: `require Agreement on Terms of Use`,
    KO: `require Agreement on Terms of Use`,
    JP: `利用規約への同意が必要です`
  }
}

const i18n_toastr = {
  _i18n_msg,
  _i18n_error
}

export default i18n_toastr